import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'

export function fieldNameOf(field: GeneratedSchemaField): string | undefined {
  return typeof field.name === 'string' ? field.name : undefined
}
